'use client';

import { useEffect } from 'react';

export const useResizeClose = (
  handler: () => void,
  enabled = true
): void => {
  useEffect(() => {
    if (!enabled) return;

    const handleResize = () => {
      handler();
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [handler, enabled]);
};
